import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../lib/api';
import { TransactionFilter } from '../types/api';
import TransactionFilters from '../components/Transactions/TransactionFilters';
import TransactionTable from '../components/Transactions/TransactionTable';
import Pagination from '../components/UI/Pagination';

const Transactions: React.FC = () => {
  const [filter, setFilter] = useState<TransactionFilter>({});
  const [page, setPage] = useState(1);
  const limit = 20;

  const { data, isLoading, refetch } = useQuery({
    queryKey: ['transactions', filter, page],
    queryFn: () => apiClient.getTransactions(filter, page, limit),
    refetchInterval: 30000,
  });

  const handleFilterChange = (newFilter: TransactionFilter) => {
    setFilter(newFilter);
    setPage(1);
  };

  const handleStatusUpdate = () => {
    refetch();
  };

  return (
    <div className="space-y-6">
      {/* Page Header */}
      <div className="border-b border-gray-200 pb-4">
        <h1 className="text-2xl font-bold text-gray-900">Bridge Transactions</h1>
        <p className="text-gray-600 mt-1">Monitor and audit all bridge transactions</p>
      </div>

      {/* Filters */}
      <TransactionFilters 
        filter={filter} 
        onFilterChange={handleFilterChange}
      />

      {/* Transactions Table */}
      <div className="bg-white rounded-lg shadow">
        <div className="px-6 py-4 border-b border-gray-200">
          <div className="flex items-center justify-between">
            <h2 className="text-lg font-medium text-gray-900">
              Transactions
              {data && (
                <span className="ml-2 text-sm text-gray-500">
                  ({data.total} total)
                </span>
              )}
            </h2>
            <button
              onClick={() => refetch()}
              className="px-4 py-2 text-sm font-medium text-blue-600 hover:text-blue-500"
            >
              Refresh
            </button>
          </div>
        </div>

        {isLoading ? (
          <div className="flex items-center justify-center py-12">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
          </div>
        ) : (
          <>
            <TransactionTable 
              transactions={data?.items || []}
              onStatusUpdate={handleStatusUpdate}
            />
            
            {data && data.pages > 1 && (
              <div className="px-6 py-4 border-t border-gray-200">
                <Pagination
                  currentPage={page}
                  totalPages={data.pages}
                  onPageChange={setPage}
                />
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default Transactions; 